import { c as _c } from "react/compiler-runtime";
import SProviderLink from 'src/components/streaming/streamingtitlewithproviders/SProviderLink';
import { isAfter, parse } from "date-fns";
import { locale } from "@locale";

//#region [Props]
type CinemaProviderProps = {
  movieId: string;
  className?: string;
  hasCinemaShows?: boolean;
  premiere?: string | Date;
};
//#endregion

//#region [Component]
export default function CinemaProvider(t0) {
  const $ = _c(4);
  const {
    movieId,
    className,
    hasCinemaShows,
    premiere
  } = t0;
  let premDate;
  let text = locale.providers.incinema;
  if (premiere && !/^0001/.test(premiere.toString())) {
    if (typeof premiere === "string") {
      premDate = /^\d{4}[.-]\d{2}[.-]\d{2}/.test(premiere) ? parse(premiere.substring(0, 10).replace(/-/g, "."), "yyyy.MM.dd", new Date()) : undefined;
    } else {
      premDate = premiere;
    }
    if (premDate) {
      if (!hasCinemaShows && isAfter(premDate, new Date())) {
        return null;
      }
      if (hasCinemaShows && isAfter(premDate, new Date())) {
        text = locale.providers.presale;
      }
    }
  }
  const t1 = `/film/${movieId}`;
  let t2;
  if ($[0] !== className || $[1] !== t1 || $[2] !== text) {
    t2 = <SProviderLink to={t1} className={className}>{text}</SProviderLink>;
    $[0] = className;
    $[1] = t1;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
//#endregion

//#region [Styles]
//#endregion